<div class="incoming-review" [ngClass]="truncateReview ? 'truncate-incoming' : ''" [style.backgroundColor]="bgcolor" [style.margin]="isWidget ? '10px 0' : ''">
    <div class="no-shadow rm-border bg-transparent widget-chart p-3 text-left text-start">
        <div *ngIf="!photo || showLetter" class="initial-letter" [ngClass]="isWidget ? 'widget' : 'review_feedback'">
            <p>{{name.charAt(0)}}</p>
        </div>
        <img *ngIf="photo && !showLetter" class="rounded-circle image-profile" [src]="photo" (error)="error()">
            
        <div class="widget-chart-content mb-1 mt-2">
            <div class="d-flex justify-content-between">
                <div class="d-flex justify-content-between w-100">
                    <div *ngIf="displayNameMode == widgetNameDisplay.Long || !displayNameMode" class="widget-subheading name">{{ (name ? name: '') + ' ' + (lastName ? lastName : '')}}</div>
                    <div *ngIf="displayNameMode == widgetNameDisplay.Short" class="widget-subheading name">{{ (name ? name: '') + ' ' + (lastName ? lastName[0] + '.' : '')}}</div>
                    <div *ngIf="showSpamButton" (click)="spamButtonClick()"  class="spam-btn">
                        <i *ngIf="isSpam" class="fas fa-exclamation-circle" style="color: #ff0000;"></i>
                        {{ isSpam ? 'Not spam' :  'Report spam'}}
                    </div>
                    <div *ngIf="((replies?.length < numberOfAllowedReplies) && (!isFeedback || isWidget) && showReplyButton && permissions.addReviewSiteToLocation) ? true : false"
                    (click)="showReplyEditor = true" class="reply-btn">Reply</div>
                </div>
                <div class="location-name">{{ location }}</div>
            </div>
            
            <div *ngIf="!isFeedback || isWidget" class="d-flex align-items-center" style="height: 24px">
                <ngb-rating 
                    [(rate)]="starPercentage"
                    readonly="true"
                    max="5">
                    <ng-template let-fill="fill" let-index="index">
                        <span class="star" [class.filled]="fill === 100">&#9733;</span>
                    </ng-template>
                </ngb-rating>
            </div>
            <div *ngIf="email" class="emailAddress" (click)="openMailClient(email)">{{ email ? email : '' }}</div>
            <div *ngIf="phone">{{ phone ? phone : '' }}</div>
            <div [innerHtml]="reviewText" class="widget-description" [ngClass]="truncateReview ? 'truncate' : ''"></div>
            <div class="bottom-content d-flex">
                <img *ngIf="siteIcon && !isFeedback && !isWidget" class="review-site" [src]="siteIcon">
                <div *ngIf="!isWidget" style="color: #b5b5b5;">{{created | date: 'short'}}</div>
                <div *ngIf="isWidget" style="color: #b5b5b5;">{{created | date: 'shortDate'}}</div>
                <div style="margin-left: 10px; font-weight: 600;" *ngIf="!isFeedback && !isWidget && integrationFlow">
                    <a style="text-decoration: none; color: #495057" [href]="reviewUrl" target="_blank">View on {{siteName}}</a>
                </div>
                <i  *ngIf="!isFeedback && !isWidget && showShareIcon" (click)="share.emit()" class="fas share-icon fa-share-alt"></i>
            </div>
            <div *ngIf="!isFeedback && !isWidget">
                <div 
                    (click)="showMore = !showMore" 
                    *ngIf="replies.length > 2" 
                    style="font-weight: 900; cursor: pointer;">{{textReplies()}}</div>
                <div class="widget-description" *ngIf="showMore || replies.length <= 2">
                        <div *ngFor="let reply of replies" class="text-left" [ngClass]="!showReplyEditor ? 'reply' : 'reply-editor'">
                                <div *ngIf="!reply.photoUrl && !showReplyEditor" class="initial-letter">
                                    <p>{{reply.senderName.charAt(0)}}</p>
                                </div>
                                <img *ngIf="reply.photoUrl && !showReplyEditor" class="rounded-circle image-profile" [src]="reply.photoUrl">
                            <div *ngIf="!showReplyEditor" class="widget-chart-content">
                                <div class="widget-subheading name d-flex">
                                    <label>{{ reply.senderName }}</label>
                                    <div *ngIf="(showEditReplyButton && permissions.addReviewSiteToLocation) ? (siteName | someIntegrationEnabled)  : false" class="edit-delete">
                                        <label (click)="showReplyEditor = true">Edit</label>
                                        <label *ngIf="!Functions.isFacebook(siteName)">&nbsp;|&nbsp;</label>
                                        <label *ngIf="!Functions.isFacebook(siteName)" (click)=deleteReply.emit()> Delete</label>
                                    </div>
                                </div>
                                <div class="widget-description" [innerHtml]="reply.messageResponse"></div>
                                <div style="color: #b5b5b5;">{{reply.dateResponse | date: 'short'}}</div>
                            </div>
                            <div *ngIf="showReplyEditor">
                                <reply-to-review
                                    [currentResponse] = "pendingReply ? pendingReply : reply.messageResponse"
                                    (post) = "createPost($event); showReplyEditor = false;"
                                    (cancel) = "showReplyEditor = false"
                                    [locationName] = "locationName"
                                    [review] = "review"
                                    [reviewTargetName] = "siteName"
                                    [isEnableOpenai] = "isEnableOpenaiIntegration"
                                >
                                </reply-to-review>
                            </div>
                        </div>
                    <div *ngIf="showReplyEditor && !replies.length">
                            <reply-to-review
                                [currentResponse] = "pendingReply"
                                (post) = "createPost($event); showReplyEditor = false;"
                                (cancel) = "showReplyEditor = false"
                                [locationName] = "locationName"
                                [review] = "review"
                                [reviewTargetName] = "siteName"
                                [isEnableOpenai] = "isEnableOpenaiIntegration"
                            >
                            </reply-to-review>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="isUnverified" class="unverified-content">
        <span class="unverified">Unverified Contact</span>
    </div>
</div>
